module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0008.jpg?v=dceaf5c7";